import { Plus, Tags, X } from "lucide-react";

// ---- Shared layout + form primitives extracted from App.js ----

export function PageTitle({ eyebrow, title, description, action, onAction, actionTest = "page-add-button" }) {
  return (
    <div className="page-title">
      <div>
        <div className="eyebrow">{eyebrow}</div>
        <h1 data-testid="page-title">{title}</h1>
        <p>{description}</p>
      </div>
      {action && <button className="primary-button" data-testid={actionTest} onClick={onAction}><Plus size={17} />{action}</button>}
    </div>
  );
}

export function Kpi({ label, value, detail, icon: Icon, color }) {
  return (
    <div className={`kpi ${color}`} data-testid={`kpi-${label.toLowerCase().replaceAll(" ", "-")}`}>
      <div className="kpi-top"><span>{label}</span><div className="kpi-icon"><Icon size={17} /></div></div>
      <strong>{value}</strong>
      <small>{detail}</small>
    </div>
  );
}

export function Empty({ text }) {
  return <div className="empty" data-testid="empty-state"><Tags size={22} /><span>{text}</span></div>;
}

export function Modal({ title, children, onClose }) {
  return (
    <div className="modal-backdrop" data-testid="modal-backdrop">
      <div className="modal">
        <div className="modal-head">
          <h2>{title}</h2>
          <button className="icon-button" data-testid="modal-close-button" onClick={onClose}><X size={18} /></button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function Field({ label, name, value, onChange, type = "text", required = false, step, hint }) {
  return (
    <label className="field">
      <span>{label}</span>
      <input data-testid={`${name}-input`} name={name} type={type} value={value ?? ""} onChange={onChange} required={required} step={step} />
      {hint && <em className="field-hint">{hint}</em>}
    </label>
  );
}

export function Select({ label, name, value, onChange, options }) {
  return (
    <label className="field">
      <span>{label}</span>
      <select data-testid={`${name}-select`} name={name} value={value ?? ""} onChange={onChange}>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </label>
  );
}
